import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
  error           : [],
  adminNotifs     : [],
  adminBarNotifs  : [],
  adminListNotifs : [],
  activityNotifs  : [],
};

export default {
  namespaced : true,
  state,
  actions,
  mutations,
  getters,
}